<template>
    <center>
    <div
        style="width: 500px!important;border: 1px solid black;margin: 5px;"
        tabindex="-1"
        aria-labelledby="offcanvasAddUserLabel"
    >
        <div class="offcanvas-header border-bottom">
            <h5 id="offcanvasAddUserLabel" class="offcanvas-title" >
                BERITA ACARA SARANA
            </h5>
        </div>
        <div class="offcanvas-body mx-0 flex-grow-0 p-6 h-100">
            <div class="col-xl">
                <form
                    @submit.prevent="send"
                    autocomplete="off"
                    autocapitalize="on"
                    enctype="multipart/form-data"
                >
                    <div class="mb-3">
                        <label class="col-sm-5 col-form-label" for=""
                            >UNIT SARANA (LIGHT VEHICLES)
                        </label>
                        <div class="col-sm-7 ">
                            <b
                            class=" form-control-plaintext "
                        >
                            {{ berita_acaras.noLambung }}
                        </b>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label class="col-sm-5 col-form-label" 
                            >Kilometer Unit
                        </label>
                        <div class="col-sm-7 ">
                            <b
                            class=" form-control-plaintext "
                        >
                            {{ berita_acaras.kilometerUnit }} KM
                        </b>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label class="col-sm-5 col-form-label" 
                            >Subjek Berita Acara
                        </label>
                        <div class="col-sm-7 ">
                            <b
                            class=" form-control-plaintext "
                        >
                            {{ berita_acaras.judulBA }}
                        </b>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label class="col-sm-5 col-form-label" 
                            >Keterangan Berita Acara
                        </label>
                        <div class="col-sm-7 ">
                            <b
                            class=" form-control-plaintext "
                        >
                            {{ berita_acaras.keteranganBA }}
                        </b>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label class="col-sm-5 col-form-label" 
                            >Lampiran Berita Acara
                        </label>
                            <a href="" target="_blank" class="col-sm-7" style="text-decoration: none!important;">
                        <i class='bx bx-file col-sm-12' style="font-size: 90px;"></i>
                            <b
                            class=" form-control-plaintext col-sm-12"
                        >
                            {{ berita_acaras.lampiranBA }}
                        </b>
                    </a>
                    </div>
                    <div class="mb-3">
                        <label class="col-sm-5 col-form-label" 
                            >MEREK - Type
                        </label>
                        <div class="col-sm-7 ">
                            <b
                            class=" form-control-plaintext "
                        >
                            {{ berita_acaras.merkType }}
                        </b>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label class="col-sm-5 col-form-label" 
                            >Tanggal
                        </label>
                        <div class="col-sm-7 ">
                            <b
                            class=" form-control-plaintext "
                        >
                            {{moment(berita_acaras.tanggal).format("DD MMMM YYYY") }}
                        </b>
                        </div>
                    </div>

                    <div class="mb-3">
                        <label class="col-sm-5 col-form-label" 
                            >Waktu
                        </label>
                        <div class="col-sm-7 ">
                            <b
                            class=" form-control-plaintext "
                        >
                            {{berita_acaras.jam }}
                        </b></div>
                    </div>
                    <div class="mb-3">
                        <label class="col-sm-5 col-form-label" 
                            >Dibuat Oleh
                        </label>
                        <div class="col-sm-7 ">
                            <b
                            class=" form-control-plaintext "
                        >
                            {{berita_acaras.nama }}
                        </b></div>
                    </div>
                    <button
                        type="reset"
                        class="btn btn-outline-danger"
                        data-bs-dismiss="offcanvas"
                    >
                        Cancel
                    </button>
                </form>
            </div>
        </div>
    </div>
    </center>
</template>
<script>
import axios from "axios";
import { uid } from 'uid';
import moment from "moment";
export default {
    mounted() {
        if (this.berita_acara != "")
            this.berita_acaras = JSON.parse(this.berita_acara);
        console.log("ba : "+this.berita_acaras.noLambung)
        // this.getSarana();
    },
    data() {
        return {
            moment:moment,
            strTime:new Date(),
            urlAction: "/",
            csrfTokens: "",
            lampiran: {},
            sarana: [],
            vehicle : [],
            chkStatus: true,
            idVehicles: null,
            users:{},
            nomorBA:uid(),
            berita_acaras:{},
            dtime:new Date()
        };
    },
    props: ["tokens", "url_action","username","berita_acara"],
    methods: {
        send() {
                 this.save();
        },
        save() {
            var a = this
            a.nomorBA = uid()
            a.lampiran.nomorBA = a.nomorBA
            var l = a.lampiran
            axios.put("/sarana/ba/"+l.uidVehicle, l).then((response) => {
                var data = response.data;
                if (data.success) {
                    document.location = data.uri
                }
            });
        },
        getSarana() {
            this.initDatas();
            axios
                .get("/sarana/lv/show")
                .then((response) => {
                    var v = response.data;
                    if (v != null) {
                        var s = {};
                        var vhc = {};
                        for(var i in v){
                            s[v[i].uidVehicle] = v[i].noLambung + " ("+v[i].noPol+")"
                            vhc[v[i].uidVehicle]= v[i].merek + " ("+v[i].type+")"
                        }
                        this.sarana = s
                        this.vehicle = vhc
                    }
                });
        },
        getUid() {
            axios.get("/get/uids").then((response) => {
                this.lampiran.uidVehicle = response.data;
            });
        },
        isNumber(evt) {
            const charCode = evt.which ? evt.which : evt.keyCode;
            if (
                charCode > 31 &&
                (charCode < 48 || charCode > 57)
            ) {
                evt.preventDefault();
            }
            },
        chgStatus() {
            this.chkStatus != this.chkStatus;
            if (this.chkStatus) {
                this.lampiran.statusCeklog = 1;
            } else {
                this.lampiran.statusCeklog = 0;
            }
        },
        selectSarana(e){
            var v = this.vehicle[e.target.value]
            this.lampiran.noLambung = this.sarana[e.target.value];
            this.lampiran.merkType = v
            this.lampiran.kodeUnit = e.target.value;
        },
        klikLampiran(){
            var myOffcanvas = document.getElementById("offcanvasLampiran");
            var bsOffcanvas = new bootstrap.Offcanvas(myOffcanvas);
            bsOffcanvas.toggle();
            return false
        },
        initDatas() {
            var hari=['Minggu', 'Senin','Selasa','Rabu','Kamis','Jumat','Sabtu'];
            var time =this.pad(this.dtime.getHours())+':'+this.pad(this.dtime.getMinutes())+':'+this.pad(this.dtime.getSeconds())
            var dt = moment().format('YYYY-MM-DD')

            this.lampiran = {};
            if (this.url_action != null) {
                this.urlAction = this.url_action;
            }
            if (this.tokens != null) {
                this.csrfTokens = this.tokens;
            }
            this.lampiran.kodeUnit = "";
            this.lampiran.status = 1;
            this.lampiran.tanggal =dt
            this.lampiran.jam = time
            this.lampiran.hari = hari[this.dtime.getDay()];
            this.lampiran.userInput = this.users.username
            this.lampiran.nama = this.users.fullName
            this.getUid();
        },
        pad(d) {
            return (d < 10) ? '0' + d.toString() : d.toString();
        },
        doEmit(e){
            this.lampiran.lampiranBA = e
        },
        disabledInput(e){
            e.preventDefault();
        }
    },
    expose: ["initDatas"],
};
</script>